import { BenefitData } from "./types";
import { BENEFIT_ICON_MAP } from "./utils";

/**
 * Benefits-specific API types
 */
export interface ApiBenefit {
  id?: string;
  icon?: {
    url?: string;
    svg?: string;
  };
  policyTitle: string;
  policyAmt: string;
}

/**
 * Transforms API benefit data into component-ready format
 */
export const transformBenefits = (apiBenefits: ApiBenefit[]): BenefitData[] => {
  return apiBenefits.map((benefit) => ({
    icon: benefit.icon || {
      url: BENEFIT_ICON_MAP[benefit.id || ""] || BENEFIT_ICON_MAP["default"],
    },
    title: {
      text: {
        value: benefit.policyTitle,
      },
    },
    amount: {
      text: {
        value: benefit.policyAmt,
      },
    },
  }));
};
